import { render, staticRenderFns } from "./ExercisePopup.vue?vue&type=template&id=3b038912&scoped=true"
import script from "./ExercisePopup.vue?vue&type=script&lang=js"
export * from "./ExercisePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b038912",
  null
  
)

export default component.exports